module.exports = __webpack_public_path__ + "static/media/farmindia_img_4.3e397d9a.png";